/** Map order status code to visual tone. Matches static order_status.tpl. */
const STATUS_TONE: Record<string, 'success' | 'danger' | 'warning' | 'info' | 'muted'> = {
  C: 'success', A: 'success', P: 'success', S: 'success', T: 'success',
  D: 'danger', F: 'danger', L: 'danger', E: 'danger', J: 'danger',
  B: 'warning', W: 'warning',
  R: 'info', K: 'info', U: 'info',
  I: 'muted', Q: 'muted',
  Completed: 'success',
};

/** @deprecated Bootstrap badge leftover — prefer getOrderStatusClass. */
const STATUS_BADGE: Record<string, string> = {
  success: 'success',
  danger: 'danger',
  warning: 'warning',
  info: 'info',
  muted: 'secondary',
};

export function getOrderStatusTone(status: string | undefined | null): 'success' | 'danger' | 'warning' | 'info' | 'muted' {
  if (status == null || status === '') return 'muted';
  return STATUS_TONE[String(status)] ?? 'muted';
}

export function getOrderStatusBadge(status: string | undefined | null): string {
  return STATUS_BADGE[getOrderStatusTone(status)] ?? 'secondary';
}

export function getOrderStatusClass(status: string | undefined | null): string {
  return `sw-order-status sw-order-status--${getOrderStatusTone(status)}`;
}

/** Statuses that need customer attention in the list. */
export function isOrderAttentionStatus(status: string | undefined | null): boolean {
  const code = String(status || '').toUpperCase();
  return code === 'Q' || code === 'F' || code === 'I';
}

export function getOrderStatusLabel(
  status: string | undefined | null,
  t: (key: string) => string
): string {
  if (status == null || status === '') return t('orders.pending');
  const code = String(status);
  const key = 'orders.status_' + (code === 'Completed' ? 'C' : code);
  const label = t(key);
  return label !== key ? label : code;
}
